import { getFamilyMembersAction } from "../../../store/family/getFamilyMembers/GetFamilyMembersSlice";
import styles from "../../../pages/subscriptions/mySubscription/MySubscription.module.css";
import { inviteMemberAction } from "../../../store/family/inviteMember/InviteMemberSlice";
import AddFamilyMemberModal from "../../modal/addFamilyMemberModal/AddFamilyMemberModal";
import getFamilyMembers from "../../../store/family/getFamilyMembers/GetFamilyMembers";
import ConfirmationModal from "../../modal/confirmationModal/ConfirmationModal";
import inviteMember from "../../../store/family/inviteMember/InviteMember";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Loader from "../../spinner/Loader";
import toast from "react-hot-toast";
import Cookies from 'js-cookie';
import deleteOrCancelMember from "../../../store/family/deleteOrCancelMember/DeleteOrCancelMember";
import { deleteOrCancelMemberAction } from "../../../store/family/deleteOrCancelMember/DeleteOrCancelMemberSlice";

export default function MembersCard({ t, subscription }) {
  const dispatch = useDispatch();
  const [membersList, setMembersList] = useState([]);
  const [loading, setLoading] = useState("list");
  const [modal, setModal] = useState(null);
  const [deletableMember, setDeletableMember] = useState(null);
  const getFamilyMembersData = useSelector((state) => state.getFamilyMembers);
  const inviteMemberData = useSelector((state) => state.inviteMember);
  const deleteOrCancelMemberData = useSelector((state) => state.deleteOrCancelMember);
  const token = Cookies.get('auth_token');

  const totalSlots = subscription.entitlements.find(item => item.type === "familySharing")?.limit;
  const emptySlots = totalSlots - membersList.length;

  useEffect(() => {
    if (token) dispatch(getFamilyMembers(token))
  }, [dispatch, token])

  useEffect(() => {
    if (getFamilyMembersData?.status === "succeeded") {
      dispatch(getFamilyMembersAction.getFamilyMembersReset());
      setMembersList(getFamilyMembersData.data.members.filter((m) => m.status !== "declined"));
      setLoading(null)
    } else if (getFamilyMembersData?.status === "failed") {
      setLoading(null)
      dispatch(getFamilyMembersAction.getFamilyMembersReset());
    }
  }, [dispatch, getFamilyMembersData, t])

  useEffect(() => {
    if (deleteOrCancelMemberData?.status === "succeeded") {
      setMembersList(prev => prev.filter(member => member.inviteId !== deletableMember));
      toast.remove()
      toast.success(t("user_successfully_deleted"));
      setModal(null)
      setLoading(null)
      dispatch(deleteOrCancelMemberAction.deleteOrCancelMemberReset());
    } else if (deleteOrCancelMemberData?.status === "failed") {
      toast.remove()
      toast.error(t(deleteOrCancelMemberData.error.Error) ?? t("unknown_error"));
      setLoading(null)
      dispatch(deleteOrCancelMemberAction.deleteOrCancelMemberReset());
    }
  }, [dispatch, deleteOrCancelMemberData, t, deletableMember])

  useEffect(() => {
    if (inviteMemberData?.status === "succeeded") {
      setMembersList(prev => [ ...prev, inviteMemberData.data ]);
      toast.remove()
      toast.success(t("invite_successfully_sent"));
      setModal(null)
      setLoading(null)
      dispatch(inviteMemberAction.inviteMemberReset());
    } else if (inviteMemberData?.status === "failed") {
      toast.remove()
      toast.error(t(inviteMemberData.error.Error) ?? t("unknown_error"));
      setLoading(null)
      dispatch(inviteMemberAction.inviteMemberReset());
    }
  }, [dispatch, inviteMemberData, t])

  function handleInviteButton(idenfivier) {
    setLoading("invite")
    dispatch(inviteMember(token, idenfivier))
  }

  function handleDeleteConfirm() {
    setLoading("delete")
    dispatch(deleteOrCancelMember(token, deletableMember))
  }

  return (
    <div className={styles.membersCard}>
      <div className={styles.membersHeader}>
        <h3 className={styles.membersTitle}>{t("family_members")}</h3>
        <span className={styles.slotBadge}>{membersList.length}/{totalSlots}</span>
      </div>

      {loading === "list" ? <Loader className={styles.customLoaderHeight}/> : (
        <div className={styles.membersGrid}>
          {membersList.map((m, index) => (
            <div className={`${styles.memberItem} ${styles.memberActive}`} key={m.name}>
              <div className={styles.memberAvatar}>
                <img src={`/assets/subscriptions/member${(index % 4) + 1}.png`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
              </div>
              <span className={styles.memberName}>{m.user?.email ?? m.user?.phoneNumber ?? m.user?.username ?? "-"}</span>
              {m.status === "pending" && (
                <span className={styles.pendingBadge}>{t("pending")}</span>
              )}
              <button className={styles.removeBtn} onClick={() => { setModal("delete"); setDeletableMember(m.inviteId) }}>
                <img src="/assets/subscriptions/delete.svg" alt="" width={17} height={17}/>
                {t("remove")}
              </button>
            </div>
          ))}

          {Array.from({ length: emptySlots }).map((_, i) => (
            <div className={`${styles.memberItem} ${styles.memberEmpty}`} key={`empty-${i}`}>
              <div className={styles.memberAvatarEmpty} onClick={() => setModal("add")}>
                <img src="/assets/subscriptions/addUser.svg" alt="" width={22} height={22}/>
              </div>
              <button className={styles.addBtn} onClick={() => setModal("add")}>{t("add")}</button>
            </div>
          ))}
        </div>
      )}

      {modal === "add" && (
        <AddFamilyMemberModal onClose={() => setModal(null)} {...{ t, loading, setLoading, handleInviteButton }}/>
      )}
      {modal === "delete" && (
        <ConfirmationModal
          show={modal === "delete"}
          onHide={() => setModal(null)}
          logOutHandler={handleDeleteConfirm}
          titles={{
            max_title: loading === "delete" ? <Loader className={styles.customLoaderHeight}/> : t("delete_family_member_title"),
            mid_title: loading === "delete" ? "" : t("delete_family_member_description")
          }}
          loading={loading === "delete"}
        />
      )}
    </div>
  )
}